import React from 'react';
import { OptionProps } from 'react-select';

interface SelectOptionWrapperProps<Option> extends OptionProps<Option, false> {
  component: React.ElementType;
}

function SelectOptionWrapper<Option>(props: SelectOptionWrapperProps<Option>) {
  const {
    className = '',
    component: Component,
    data,
    innerProps,
    innerRef,
    isDisabled,
    isFocused,
    isSelected
  } = props;

  const { tabIndex: _tabIndex, ...allOtherParams } = innerProps;
  const modifiedInnerParams = {
    ...allOtherParams,
    'aria-selected': isSelected,
    role: 'option'
  };
  let classNames = `${className} react-select__option`;

  if (isDisabled) {
    classNames = `${classNames} react-select__option--is-disabled`;
  } else if (isSelected) {
    classNames = `${classNames} react-select__option--is-selected`;
  } else if (isFocused) {
    classNames = `${classNames} react-select__option--is-focused`;
  }

  return (
    <div {...modifiedInnerParams} className={classNames} ref={innerRef}>
      <Component {...data} isFocused={isFocused} isSelected={isSelected} />
    </div>
  );
}

export default SelectOptionWrapper;
